import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IssuingProviderNames = {
  STRIPE: 'stripe',
  AIRWALLEX: 'airwallex',
} as const

export type IssuingProviderNameEnum = Enum<typeof IssuingProviderNames>
